import initialState from './initialState';
import { types } from '../actions/budgetActions';
import { BudgetModel } from '../models/BudgetModel';

export default function budgetReducer(state = initialState.budget, action) {
  switch (action.type) {
    case types.GET_BUDGET: {
      return { fetching: true, current: null, success: false, voteError: null, saving: false };
    }
    case types.GET_BUDGET_FAILURE: {
      return { fetching: false, current: null, success: false, voteError: null, saving: false };
    }
    case types.GET_BUDGET_SUCCESS: {
      const { budget } = action;
      return {
        fetching: false,
        current: Object.assign(new BudgetModel(), budget),
        success: false,
        voteError: null,
        saving: false,
      };
    }
    case types.APPLICATION_SUCCESS: {
      return {
        fetching: false,
        current: Object.assign(new BudgetModel(), state.current),
        success: true,
        voteError: null,
        saving: false,
      };
    }  
    case types.GET_BUDGET_WITH_MY_APPLICATION: {
      return { fetching: true, current: null, success: false, voteError: null, saving: false };
    }
    case types.GET_BUDGET_WITH_MY_APPLICATION_SUCCESS: {
      const budgetWithApplication = action.budget;
      return {
        fetching: false,
        current: Object.assign(new BudgetModel(), budgetWithApplication),
        success: false,
        voteError: null,
        saving: false,
      };
    }
    case types.GET_BUDGET_WITH_MY_APPLICATION_FAILURE: {
      return { fetching: false, current: null, success: false, voteError: null, saving: false };
    }
    case types.APPLICATION_SAVE:
      return { 
        fetching: state.fetching, 
        current: state.current, 
        success: state.success, 
        voteError: state.voteError, 
        saving: true, 
      };
    case types.APPLICATION_SAVE_SUCCESS:
      return { 
        fetching: state.fetching,
        current: state.current,
        success: false,
        voteError: state.voteError,
        saving: false,
      };
    case types.APPLICATION_SAVE_FAILURE:
      return { 
        fetching: state.fetching,
        current: state.current,
        success: false,
        voteError: state.voteError,
        saving: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/budgetReducer.js